export default __webpack_public_path__ + "static/media/search.11005500.svg";